import { STATIC_MODAL_CLASSNAME } from '../constants';

export default () => {
  const modals = document.querySelectorAll(`.${STATIC_MODAL_CLASSNAME}`);
  return Boolean(modals.length);
};
